import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-radio.css'
import clsx from 'clsx'

import type { RadioButtonProps } from './types'

const RadioButton = ({ item, checked, className, handlerClickRadioButton }: RadioButtonProps) => {
  const radioButtonClassName = clsx('hot-form hot-form--custom hot-form--radio', className)

  return (
    <div className={radioButtonClassName}>
      <input
        type='radio'
        className='hot-form__input'
        id={item.value}
        name={item.label}
        onChange={() => handlerClickRadioButton(item.value)}
        checked={checked}
      />
      <label className='hot-form__label' htmlFor={item.value}>
        {item.label}
      </label>
    </div>
  )
}

export default RadioButton
